<template>
  <div>
    <template v-if="content && !edit">
      <div v-html="content"></div>
    </template>
    <div v-if="content && edit">
      <vue-editor v-model="content" :editor-toolbar="toolbarOptions" />
    </div>
    <div class="my-5 text-center">
      <button v-if="!edit" type="button" class="btn btn-sm btn-outline-secondary" @click="toggleEditMode">수정</button>
      <button v-if="edit" type="button" class="btn btn-sm btn-outline-secondary" @click="save">저장</button>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';

export default {
  name: 'AdminPrivacy',
  components: {
    VueEditor,
  },
  data() {
    return {
      content: null,
      edit: false,
      toolbarOptions: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'],

        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ direction: 'rtl' }], // text direction

        [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        [{ align: [] }],

        ['clean'], // remove formatting button
      ],
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      await this.$axios.get('/api/privacy')
        .then((res) => {
          this.content = res.data.content;
        });
    },
    toggleEditMode() {
      this.edit = !this.edit;

      this.refresh();

      window.scrollTo(0, 0);
    },
    save() {
      this.$axios.post('/admin/privacy', {
        content: this.content,
      }).then(() => {
        this.toggleEditMode();
      });
    },
  },
};
</script>

<style scoped>

</style>
